import { Button } from '@components';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import { StyledContainer } from './InvestmentFooter.styles';
import { InvestmentFooterProps } from './InvestmentFooter.types';

const InvestmentFooter: React.FC<InvestmentFooterProps> = ({
  secondaryButton,
  primaryButton,
}) => {
  const { sm: isMobile } = useMediaQueries();
  return (
    <StyledContainer>
      {secondaryButton?.title ? (
        <Button
          data-testid='secondary-button-investment-footer'
          variant='secondary'
          fullWidth={isMobile}
          {...secondaryButton}
        >
          {secondaryButton?.title}
        </Button>
      ) : null}
      {primaryButton?.title ? (
        <Button
          data-testid='primary-button-investment-footer'
          variant='primary'
          fullWidth={isMobile}
          {...primaryButton}
        >
          {primaryButton?.title}
        </Button>
      ) : null}
    </StyledContainer>
  );
};

export default InvestmentFooter;
